<template>
	<div style="width:90%">
		<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
		    <el-form-item style="width:40%">
		        <template>
		            <el-button type="primary" @click="search">查询</el-button>
		            <el-button @click="empty">清空</el-button>
		            <el-button type="primary" @click="editialogVisible('')">新增
		            </el-button>
		        </template>
		    </el-form-item>
		</el-form>
		<el-table :data="sliderList" stripe style="width: 100%">
			<!-- <el-table-column type="index" align="center" label="#" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="title" label="标题" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="content" label="轮播图片" width="180" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.content" :src="scope.row.content" width="50px" @click="
						dialogImageUrl = scope.row.content;
						dialogVisibleImg = true;
					" />
					<div v-else>暂无图片</div>
				</template>
			</el-table-column>
			<el-table-column prop="typeName" label="位置" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="action" label="类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.action=='good'">商品</span>
					<span v-if="scope.row.action=='url'">链接</span>
					<span v-if="scope.row.action=='richtext'">富文本</span>
					<span v-if="scope.row.action=='richtext'">文本</span>
					<span v-if="scope.row.action=='richtext'">无</span>
					<span v-if="scope.row.action=='richtext'">快讯</span>
					<span v-if="scope.row.action=='richtext'">新闻</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="action" label="类型" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="详情" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row.id)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="orders" label="轮播顺序" width="" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isJump" label="是否跳转" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.isJump==true">是</span>
					<span v-if="scope.row.isJump==false">否</span>
				</template>
			</el-table-column>
			<el-table-column prop="isEnable" label="是否启用" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.isEnable==true">是</span>
					<span v-if="scope.row.isEnable==false">否</span>
				</template>
			</el-table-column>
			<el-table-column prop="createDate" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center" width="150px" fixed="right">
				<template slot-scope="scope">
					<!-- v-if="scope.row.storeId==storeId" -->
					<el-button  size="small" type="text" @click="editialogVisible(scope.row.id);title='编辑'">编辑
					</el-button>
					<el-button style="color: red;" v-if="scope.row.isEnable" size="small" type="text" @click="editstates(scope.row.id)">
						停用
					</el-button>
					<el-button v-else size="small" type="text" @click="editstates(scope.row.id)">
						启用
					</el-button>
				
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 查看图片 -->
		<el-dialog :visible.sync="dialogVisibleImg" :close-on-click-modal="false">
			<div style="text-align: center">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="" />
			</div>
			<div style="text-align: center">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 新增、编辑修改 -->
		<el-dialog :visible.sync="editialogVisibleSwiper" :title="title+'轮播图'" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="标题" label-width="120px">
							<el-input type="text" v-model="storeGoodsInfo.title" auto-complete="off" 
							placeholder="请输入标题" style="width:200px;"/>
						</el-form-item>
						<el-form-item label="排序" label-width="120px">
							<el-input type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
								v-model="storeGoodsInfo.orders" auto-complete="off" placeholder="请输入排序" style="width:200px;"/>
						</el-form-item>
					</div>
					<!-- <el-form-item label="请选择类型">
						<el-select v-model="storeGoodsInfo.type" class="big" placeholder="请选择"
							@change="getStoreAndUser">
							<el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label">
							</el-option>
						</el-select>
					</el-form-item> -->
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="请选择位置" label-width="120px">
							<el-select v-model="storeGoodsInfo.type" placeholder="请选择" style="width:200px;">
								<el-option v-for="(item,index) in typeDataList" :key="index"
								:value="item.typeKey" :label="item.typeName"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="请选择类型" label-width="120px">
							<el-select v-model="storeGoodsInfo.action" placeholder="请选择" style="width:200px;"
							@change="selectAction">
								<el-option value="goods" label="商品"></el-option>
								<el-option value="url" label="链接"></el-option>
								<el-option value="richtext" label="富文本"></el-option>
								<el-option value="forum" label="论坛"></el-option>
								<el-option value="" label="无"></el-option>
							</el-select>
						</el-form-item>
					</div>

					<div style="border: 1px solid lightgrey;padding: 10px;" v-if="storeGoodsInfo.action=='goods'">
						<div style="text-align: left;">
							选择商品：
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="商品名称">
								<el-input type="text" clearable v-model="storeGoodsInfo.goodsName1"
									placeholder="请输入商品名称(搜索条件)" />
							</el-form-item>
							<el-form-item label="商品编号">
								<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode"
									placeholder="请输入商品编号(搜索条件)" />
							</el-form-item>
							<el-form-item label="搜索按钮">
								<el-button type="primary" @click="searchStore">搜 索</el-button>
							</el-form-item>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="选择商品">
								<el-select v-model="storeGoodsInfo.url" class="big" placeholder="请选择"
									@change="getStoreAndUsers" clearable>
									<el-option v-for="item in accountList" :key="item.id" :value="item.id"
										:label="item.goodsName+'('+item.goodsCode+')'" style="width:700px;">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>

					<el-form-item label="链接" v-if="storeGoodsInfo.action=='url'" label-width="120px">
						<el-input type="text" v-model="storeGoodsInfo.url" auto-complete="off" placeholder="请输入跳转链接" />
					</el-form-item>

					<el-form-item v-if="storeGoodsInfo.action=='richtext' || storeGoodsInfo.action=='forum'"
					 label="通知内容" label-width="120px">
						<div id="lpc-quill" class="quill" style="height:400px;">
							<el-upload v-show="false" ref="upload" class="upload-demo" :action="httpUrl"
								:before-upload="beforeUpload" :on-success="upScuccess" :on-error="uploadError" />
							<quill-editor v-model="storeGoodsInfo.url" ref="myQuillEditor" class="editer"
								:options="editorOption" @ready="onEditorReady($event)" style="height:300px;">
							</quill-editor>
						</div>
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="是否启用" label-width="120px">
							<el-switch v-model="storeGoodsInfo.isEnable" :active-value="true" :inactive-value="false"
								class="switchss">
							</el-switch>
						</el-form-item>
						<el-form-item label="是否跳转" label-width="120px">
							<el-switch v-model="storeGoodsInfo.isJump" :active-value="true" :inactive-value="false"
								class="switchss">
							</el-switch>
						</el-form-item>
					</div>
					<el-form-item label="轮播图片(限制1张)"  style="width: 100%;display: flex;align-items: initial;">
						<br />
						<el-upload :action="httpUrl" list-type="picture-card" :before-upload="beforeUploaden"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="fileList"
							:show-file-list="true" :on-success="onSuccess" multiple :limit="1">
							<i class="el-icon-plus"></i>
						</el-upload>
						<!-- span v-if="storeGoodsInfo.type=='首页'" style="padding-left: 10px;">建议上传尺寸为700*425</span>
						<span v-if="storeGoodsInfo.type=='小超广告'" style="padding-left: 10px;">建议上传尺寸为750*360</span> -->
					</el-form-item>
					<el-button type="primary" round @click="submit" v-if="title=='新增'" :loading="submitLoading">新增</el-button>
					<el-button type="primary" round @click="submitmodify" v-if="title=='编辑'" :loading="submitmodifyLoading">编辑</el-button>
				</el-form>
			</div>

		</el-dialog>
		<!-- 查看 -->
		<el-dialog title="提示" :visible.sync="showContentDialog" width="50%" :close-on-click-modal="false">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>


<script>
	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('swiper');
	export default {
		components: {
			quillEditor
		},
		data() {
			return {
				sliderList: [],
				storeGoodsInfoGoodsName: '',
				goodsImages: [],
				accountList: [],
				searchInfo:{},
				storeGoodsInfo: {
					isJump: true,
					isEnable: false
				},

				httpUrl: urls,
				fileList: [],
				types: [],
				page: {
					pageNum: 1,
					pageSize: 10,

				},
				id: '',
				title: '',
				storeId:'',
				sliderlist: {},
				storelist:[],
				dialogImageUrl: "",
				dialogVisibleImg: false,
				dialogVisibleSwiper: false,
				editialogVisibleSwiper: false,
				showContentDialog: false,
				contentValue: "",
				editorOption: { // 富文本编辑器配置
					placeholder: '请输入内容',
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
								[{
									'header': 1
								}, {
									'header': 2
								}], // 标题，键值对的形式；1、2表示字体大小
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], // 列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'align': []
								}], // 对齐方式
								['clean'], // 清除字体样式
								['image'] // 上传图片、上传视频
							],
							handlers: {
								'image': function(value) {
									if (value) {
										document.querySelector('#lpc-quill .upload-demo input').click()
									} else {
										this.quill.format('image', false)
									}
								}
							}
						}
					},
					theme: 'snow'
				},
				typeDataList: [],

				submitLoading: false,
				submitmodifyLoading: false,

			};

		},
		methods: {
			addDialogClose() {
				this.fileList = []
				this.storeGoodsInfo = {}
			},
			showContent(e) {
				this.$api.sysSliderInfo(e).then((res) => {
					if (res.state == 'success') {
						this.contentValue = res.data.url
					}
				})

				// this.contentValue = e
				this.showContentDialog = true
			},
			onSuccess(response, file, fileList) {
				this.storeGoodsInfo.content = response.message
				// console.log('ssssss',response.data);
			},
			handleRemove(file, fileList) {
				if (file.url) {
					// console.log('sds',file.url);
					this.storeGoodsInfo.content.remove(file.url);
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				// console.log('sds', file.url);
				this.dialogVisibleImg = true;
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message({
						message: "上传图片大小不能超过 8MB!",
						type: 'error'
					});
				}
				return isLt2M;
			},
			sysSliderList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// storeId:this.searchInfo.storeId
				};
				this.$api.sysSliderList(data).then((res) => {
					if (res.state == "success") {
						// console.log(res);
						this.sliderList = res.data.list;
						this.sliderlist = res.data
						// console.log("ss", this.sliderlist);
					}
				});
				// this.$api.getStoreGoodsList({}).then((res) => {
				// 	if (res.state == 'success') {
				// 		if (res.data.list[0]) {
				// 			this.storeGoodsInfo.goodsName = res.data.list[0].goodsName
				// 			this.storeGoodsInfo.objId = res.data.list[0].id
				// 		}
				// 	}
				// })
			},
			
			// 新增
			submit() {
				this.submitLoading = true;
				let data = {
					title: this.storeGoodsInfo.title,
					orders: this.storeGoodsInfo.orders,
					type: this.storeGoodsInfo.type,
					action: this.storeGoodsInfo.action,
					content: this.storeGoodsInfo.content,
					isEnable: this.storeGoodsInfo.isEnable,
					url: this.storeGoodsInfo.url,
					isJump: this.storeGoodsInfo.isJump
					// id:this.id
				}
				this.$api.addSysSliderInf(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editialogVisibleSwiper = false
						this.sysSliderList();
						this.storeGoodsInfo = ''
						this.fileList = []
					} else {
						this.$message.error(res.message);
						this.editialogVisibleSwiper = false
					}
					this.submitLoading = false;
					// this.editialogVisibleSwiper = false
				})
			},
			editstates(id){
				this.$api.editstates(id).then(res=>{
					// console.log(res)
					this.$message({
						message: res.message,
						type: 'success'
					});
					this.sysSliderList();
				})
			},
			search(){
				this.sysSliderList()
			},
			empty() {
			    this.searchInfo = {}
			},
			// 搜索
			searchStore() {
				let data = {
					goodsCode: this.storeGoodsInfo.goodsCode,
					goodsName: this.storeGoodsInfo.goodsName1,
				}
				this.$api.getStoreGoodsList(data).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.storeGoodsInfo.goodsName = res.data.list[0].goodsName
						this.storeGoodsInfo.url = res.data.list[0].id
						this.accountList = res.data.list

					}
				})

			},
			getStoreAndUsers(val) {
				this.storeGoodsInfo.url = val
			},
			// 删除
			toDelete(e) {
				var str = "此操作将删除该轮播, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delSysSliderInfo(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.sysSliderList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			selectAction(){
				this.storeGoodsInfo.url = "";
			},
			// 编辑
			editialogVisible(e) {
				this.storeInfo = {}
				this.title = '新增'
				if (e) {
					this.title = '编辑'
					this.id = e
					this.$api.sysSliderInfo(e).then((res) => {
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							if (res.data.action == 'good') {
								this.storeGoodsInfo.url = parseInt(res.data.url)
							}
							this.storeGoodsInfo.isEnable = res.data.isEnable
							if (this.fileList.length < 1) {
								this.fileList.push({
									name: res.data.content,
									url: res.data.content
								});
							}
						}
					})
				}
				this.$api.getStoreGoodsList().then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.accountList = res.data.list
					}
				})
				this.editialogVisibleSwiper = true
			},
			submitmodify() {
				this.storeGoodsInfo.id = this.id
				let data = this.storeGoodsInfo
				this.submitmodifyLoading = true;
				this.$api.editSysSliderInfo(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editialogVisibleSwiper = false
						this.sysSliderList();

					} else {
						this.$message.error(res.message);
					}
					this.submitmodifyLoading = false;
				})
			},

			getStoreAndType() {
				this.$api.findSysSliderTypeList().then((res) => {
					if (res.state == 'success') {
						this.types = res.data.list
					}
				})
			},
			getStoreAndUser(val) {
				this.storeGoodsInfo.type = val
			},
			pageChange(data) {
				this.page.pageNum = data
				this.sysSliderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.sysSliderList()
			},
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
				}
				return isLt2M;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadError() {
				this.$message.error('图片上传失败')
			},
			onEditorReady(editor) { // 准备编辑器
			},
			beforeUploaden(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
				}
				return isLt2M;
			},
			upScuccessen(res, file) {
				const quill = this.$refs.myQuillEditoren.quill
				if (res.state === 'success' && res.data !== null) {
					const length = quill.getSelection().index // 获取光标所在位置
					quill.insertEmbed(length, 'image', res.data) // 插入图片
					quill.setSelection(length + 1) // 调整光标位置到最后
				} else {
					this.$message.error('图片上传失败')
				}
			},
			uploadErroren() {
				this.$message.error('图片上传失败')
			},
			onEditorReadyen(editor) { // 准备编辑器
			},
		},

		created() {
			this.storeId=sessionStorage.getItem('storeId')
			this.sysSliderList();
			// this.sysSliderInfo()
			this.$api.getAdvertisingTypeList().then(res=>{
				// console.log('位置---', res.data)
				this.typeDataList=res.data;
			})
		},
	};
</script>

<style>
	.top {
		padding: 30px 0;
		margin-left: 50px;
	}

	.el-form-item__content {
		display: flex;
	}

	/* .el-form-item redItem{
  display: flex;
  align-items: center;
} */
	.switchss {
		margin-top: 10px;

	}
</style>
